// src/theme/chartSetup.js
// Chart.js registration shared by every page (imported once in src/index.js).
// The home page used to do this on import; pages now load lazily, so the
// registration lives here to keep every chart's plugins the same as before.
import "chart.js/auto";
import { Chart as ChartJS } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import { applyChartJsDefaults } from "./minimalTheme";

ChartJS.register(ChartDataLabels, MatrixController, MatrixElement);
applyChartJsDefaults(ChartJS);

export default ChartJS;
